import React, { useState } from 'react';
import axios from 'axios';
import { Loader2, CheckCircle2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const ContactForm = ({ source = 'contact', includeOrganisation = false, submitLabel = 'Send Message' }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [organisation, setOrganisation] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError('');
    setSubmitting(true);
    try {
      await axios.post(`${API}/api/contact`, {
        name: name.trim(),
        email: email.trim().toLowerCase(),
        organisation: includeOrganisation ? organisation.trim() : undefined,
        message: message.trim(),
        source,
      });
      setDone(true);
      setName('');
      setEmail('');
      setOrganisation('');
      setMessage('');
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Could not send. Please email hello@icraftz.com');
    } finally {
      setSubmitting(false);
    }
  };

  if (done) {
    return (
      <div className="contact-success" data-testid="contact-success">
        <CheckCircle2 size={42} />
        <h3>Thank you.</h3>
        <p>Your message has reached us. We'll be in touch shortly at the email you provided.</p>
      </div>
    );
  }

  return (
    <form className="contact-form" onSubmit={onSubmit} data-testid={`contact-form-${source}`}>
      <label className="contact-field">
        <span>Name</span>
        <input
          type="text" value={name} onChange={(e) => setName(e.target.value)}
          required maxLength={120} autoComplete="name" data-testid="contact-name"
        />
      </label>
      {includeOrganisation && (
        <label className="contact-field">
          <span>Organisation <em>(optional)</em></span>
          <input
            type="text" value={organisation} onChange={(e) => setOrganisation(e.target.value)}
            maxLength={200} data-testid="contact-organisation"
          />
        </label>
      )}
      <label className="contact-field">
        <span>Email</span>
        <input
          type="email" value={email} onChange={(e) => setEmail(e.target.value)}
          required autoComplete="email" data-testid="contact-email"
        />
      </label>
      <label className="contact-field">
        <span>Message</span>
        <textarea
          value={message} onChange={(e) => setMessage(e.target.value)}
          rows={5} required minLength={4} maxLength={4000} data-testid="contact-message"
        />
      </label>
      {error && <p className="contact-error">{error}</p>}
      <button type="submit" className="contact-submit" disabled={submitting} data-testid="contact-submit">
        {submitting ? <Loader2 size={16} className="spin" /> : submitLabel}
      </button>
      <p className="contact-foot">By submitting, you agree to our <a href="/privacy">Privacy Policy</a>.</p>
    </form>
  );
};

export default ContactForm;
